/** 视觉规格 §15 的三档中奖反馈。 */
export type WinTier = 'none' | 'toast' | 'highlight' | 'jackpot';

/** D4 的金币雨触发线（BRL）。3 位档 R$600 会触发，头奖必然触发。 */
export const COIN_RAIN_MIN_BRL = 100;

/**
 * 一张已结算的票该给什么反馈。视觉规格 §15。
 *
 * <p>`matched` 与 `payout` **都来自后端**。前端既不判输赢也不算奖金 ——
 * 头奖是按注额在赢家之间平分的，前端根本推不出来，而这里推错就是把错的
 * 金额甩到玩家脸上。
 *
 * @param jackpotDigits 头奖需要命中的位数（MADURO 时会降一位，所以必须传进来，
 *                      不能写死 4）
 */
export function winTier(
  matched: number | null,
  payoutBrl: number,
  jackpotDigits: number,
): WinTier {
  // 必须挡住非有限值：后端还没下发 payout 时前端拿到 undefined，
  // Number(undefined) 是 NaN，而 NaN <= 0 为 false —— 不挡的话每一张输的票
  // 都会显示「你赢了 R$ NaN」。契约演进期这种缝隙一定会出现。
  if (matched === null || !Number.isFinite(payoutBrl) || payoutBrl <= 0) return 'none';
  if (matched >= jackpotDigits) return 'jackpot';
  if (matched >= 3) return 'highlight';
  return 'toast';
}

/** 金币雨只看金额，不看档位 —— 与 D4 的全站规则一致，Milhar 不另立门槛。 */
export function showsCoinRain(payoutBrl: number): boolean {
  return Number.isFinite(payoutBrl) && payoutBrl >= COIN_RAIN_MIN_BRL;
}

/**
 * 一次揭晓里最该被看见的那张票。
 *
 * <p>同一期可能有多张票（数量 > 1，或 Teimosinha 与散票并存）。全屏时刻只能有
 * 一个，取**赢得最多**的那张；金额相同则取命中位数更高的 —— 头奖优先于固定档。
 */
export function headlineBet<T extends { matched: number | null; payout: number }>(
  bets: readonly T[],
): T | null {
  let best: T | null = null;
  for (const bet of bets) {
    if (bet.payout <= 0) continue;
    if (
      best === null
      || bet.payout > best.payout
      || (bet.payout === best.payout && (bet.matched ?? 0) > (best.matched ?? 0))
    ) {
      best = bet;
    }
  }
  return best;
}
